import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MissingDriverDocumentFilterEntity } from '../../domain/entities/MissingDriverDocumentFilterEntity'

export class MissingDriverDocumentFilterModel extends MissingDriverDocumentFilterEntity {
  driverId?: number
  regionId?: number

  constructor(dataDto: MissingDriverDocumentFilterEntity) {
    super()
    mapEntityProperties<MissingDriverDocumentFilterModel>(this, dataDto, {
      exclude: ['driver', 'region'],
      map: {
        driverId: dataDto.driver?.id,
        regionId: dataDto.region?.id
      }
    })
  }
}
